module.exports = __webpack_public_path__ + "img/icon_search_helmet_normal.471d6f18.png";